import PlayerDrawing from './player-drawing';

export default PlayerDrawing;
